import axios from 'axios';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { InitState, LocalStorageText } from '../constants/common.js';
import { setNavigate, navigateTo } from './navigationRef.js';

export const baseURL = 'https://qafqtior.digiin.vn/api';
let headers = {};
const instance = axios.create({
  baseURL,
  headers,
});

instance.interceptors.request.use(async (config) => {
  config.metadata = { startTime: new Date() };
  const isTokenHave = localStorage.token && localStorage.token !== InitState;
  if (isTokenHave && !config["unuse-authorization"]) {
    config.headers['Authorization'] = 'Bearer ' + localStorage.token;
  }
  return config;
});

instance.interceptors.response.use(
  (response) => {
    const endTime = new Date();
    const startTime = response.config.metadata.startTime;
    const duration = endTime - startTime;
    if (response.headers['content-length'] > 1000000 || duration > 3000) {
      console.warn(`API Request to ${response.config.url} took ${duration}ms, size: ${response.headers['content-length'] || 'unknown'} bytes`);
    }
    return Promise.resolve(response?.data);
  },
  (error) => {
    if (error.response) {
      const endTime = new Date();
      const startTime = error.config.metadata.startTime;
      const duration = endTime - startTime;
      console.error(`API Error to ${error.config.url} took ${duration}ms:`, error.message);
      const errorHttpCode = [401, 403];
      const status = error?.response?.status || 500;
      if (errorHttpCode.includes(status)) {
        localStorage.removeItem(LocalStorageText.Token);
        localStorage.removeItem('user');
        navigateTo('/login');
        return;
      }
      return Promise.reject({...error?.response?.data, status});
    }
    throw error;
  }
);

const AxiosInterceptor = ({ children }) => {
  const navigate = useNavigate();
  useEffect(() => {
    setNavigate(navigate);
  }, [navigate]);
  return children;
};

export default instance;
export { AxiosInterceptor };
